module.exports = __webpack_public_path__ + "img/xmark.e799d5e0.svg";